

































































import Vue from 'vue';
type Many<T> = T | ReadonlyArray<T>;

export default Vue.extend({
  metaInfo() {
    return {
      title: 'Sessions -'
    };
  },
  name: 'Sessions',
  components: {},
  data: () => ({
    searchQuery: '',
    sort: 'asc' as Many<boolean | 'asc' | 'desc'>,
    sortItems: [
      { text: 'Desc', value: 'desc' },
      { text: 'Asc', value: 'asc' }
    ]
  }),
  computed: {}
});
